import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
interface MenuItem {
  title: string;
  url: string;
  children?: {
    title: string;
    url: string;
  }[];
}
// Self-contained mobile menu definition.
const menuItems: MenuItem[] = [{
  title: 'Classes & Programs',
  url: '/programs',
  children: [{
    title: 'All Classes & Programs',
    url: '/programs'
  }, {
    title: 'Mini Troopers (Ages 3–5)',
    url: '/mini-troopers'
  }, {
    title: 'Kids Classes',
    url: '/karate-kids-classes.html'
  }, {
    title: 'Adult Classes',
    url: '/karate-adult-classes'
  }, {
    title: 'Family Martial Arts',
    url: '/family-martial-arts-classes'
  }, {
    title: 'Self-Defense',
    url: '/self-defense-classes-in-farmington-hills-michigan'
  }, {
    title: 'Competition Team',
    url: '/competition-team'
  }, {
    title: 'Summer Camp',
    url: '/summer-camp'
  }]
}, {
  title: 'Summer Camp',
  url: '/summer-camp'
}, {
  title: 'Reviews',
  url: '/reviews'
}, {
  title: 'Coaches',
  url: '/coaches'
}, {
  title: 'Schedule',
  url: '/schedule'
}, {
  title: 'Contact',
  url: '/contact'
}];
export function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [openItem, setOpenItem] = useState<string | null>(null);
  const onClose = () => setIsOpen(false);
  return <>
      {/* Mobile Menu Button */}
      <button type="button" className="lg:hidden p-2 text-ink" onClick={() => setIsOpen(open => !open)} aria-label="Toggle menu" aria-expanded={isOpen} data-id="element-318">
        {isOpen ? <X className="w-8 h-8" data-id="element-319" /> : <Menu className="w-8 h-8" data-id="element-320" />}
      </button>

      {isOpen && <div className="lg:hidden absolute top-20 left-0 w-full bg-paper border-b border-subtle-gray shadow-xl py-4 px-4 flex flex-col gap-4 max-h-[calc(100vh-5rem)] overflow-y-auto" data-id="element-321">
          {menuItems.map(item => item.children && item.children.length > 0 ? <div key={item.title} className="border-b border-subtle-gray pb-2" data-id="element-322">
                <div className="flex items-center justify-between" data-id="element-323">
                  {item.url ? <a href={item.url} className="text-lg font-bold text-ink py-2" onClick={onClose} data-id="element-324">
                      {item.title}
                    </a> : <span className="text-lg font-bold text-ink py-2" data-id="element-325">
                      {item.title}
                    </span>}
                  <button type="button" onClick={() => setOpenItem(current => current === item.title ? null : item.title)} aria-expanded={openItem === item.title} aria-label={`Toggle ${item.title} submenu`} className="p-2 text-ink" data-id="element-326">
                    <svg className={`w-5 h-5 transition-transform ${openItem === item.title ? 'rotate-180' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-327">
                      <path d="m6 9 6 6 6-6" data-id="element-328" />
                    </svg>
                  </button>
                </div>
                {openItem === item.title && <ul className="flex flex-col pl-3 pb-1" data-id="element-329">
                    {item.children.map(child => <li key={child.title} data-id="element-330">
                        <a href={child.url} className="block py-2 text-base font-medium text-gray-warm hover:text-storm-red transition-colors" onClick={onClose} data-id="element-331">
                          {child.title}
                        </a>
                      </li>)}
                  </ul>}
              </div> : <a key={item.title} href={item.url} className="text-lg font-bold text-ink py-2 border-b border-subtle-gray" onClick={onClose} data-id="element-332">
                {item.title}
              </a>)}
          <div className="pt-4 flex flex-col gap-4" data-id="element-333">
            <a href="tel:517-220-0621" className="flex items-center justify-center gap-2 text-ink font-bold py-3 bg-subtle-gray rounded-xl" data-id="element-334">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-335">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-336" />
              </svg>
              <span data-id="element-337">Call 517-220-0621</span>
            </a>
            <a href="/SignMeUp" className="btn-primary w-full" onClick={onClose} data-id="element-338">
              Start Trial Class
            </a>
          </div>
        </div>}
    </>;
}